import { render, staticRenderFns } from "./BrandMaintain.vue?vue&type=template&id=31d846a2"
import script from "./BrandMaintain.vue?vue&type=script&lang=js"
export * from "./BrandMaintain.vue?vue&type=script&lang=js"
import style0 from "./BrandMaintain.vue?vue&type=style&index=0&id=31d846a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports